import React, { useEffect, useReducer, useRef } from 'react';
import { Container } from 'react-bootstrap';
import CheckoutSteps from './CheckoutSteps';

import { AiFillCreditCard, AiFillCalendar } from 'react-icons/ai';
import { MdVpnKey } from 'react-icons/md';
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
    useElements,
    useStripe,
} from '@stripe/react-stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { clearErrors, createOrder } from '../../redux/actions/orderActions';
import MetaData from '../MetaData';
import { URL } from '../../Routing';
import Cookies from 'universal-cookie';

const Payment = () => {
    const payBtn = useRef();
    const elements = useElements();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const stripe = useStripe();
    const orderInfo = JSON.parse(sessionStorage.getItem('orderInfo'));
    const { shippingInfo, cartItems } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.user);
    const { error } = useSelector((state) => state.newOrder);

    const paymentData = {
        amount: Math.round(orderInfo.totalPrice * 100), // convert in paisa
    };

    const order = {
        shippingInfo,
        orderItems: cartItems,
        itemsPrice: orderInfo.subtotal,
        taxPrice: orderInfo.tax,
        shippingPrice: orderInfo.shippingCharges,
        totalPrice: orderInfo.totalPrice,
    };

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        payBtn.current.disabled = true;
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: new Cookies().get('token'),
                },
            };
            const { data } = await axios.post(`${URL}/api/v1/payment/process`, paymentData, config);
            const client_secret = data.client_secret;
            if (!stripe || !elements) return;
            const result = await stripe.confirmCardPayment(client_secret, {
                payment_method: {
                    card: elements.getElement(CardNumberElement),
                    billing_details: {
                        name: user.name,
                        email: user.email,
                        address: {
                            line1: shippingInfo.address,
                            city: shippingInfo.city,
                            state: shippingInfo.state,
                            postal_code: shippingInfo.pinCode,
                            country: shippingInfo.country,
                        },
                    },
                },
            });
            if (result.error) {
                payBtn.current.disabled = false;
                toast.error(result.error.message);
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    order.paymentInfo = {
                        id: result.paymentIntent.id,
                        status: result.paymentIntent.status,
                    };
                    dispatch(createOrder(order));
                    navigate('/success');
                    localStorage.removeItem('cartItems');
                } else {
                    toast.error("There's some issue while processing payment");
                }
            }
        } catch (error) {
            payBtn.current.disabled = false;
            toast.error(error.response.data.message);
        }
    };

    return (
        <>
            <MetaData title='Payment' />
            <div className='section-padding-top section-padding-bottom'>
                <Container>
                    <CheckoutSteps activeStep={2} />
                    <div className='paymentContainer'>
                        <form onSubmit={handleSubmit}>
                            <h4 className='text-center formHeading mb-5'>Card Info</h4>
                            <div className='cardInputBlock'>
                                <AiFillCreditCard />
                                <CardNumberElement className='paymentInput' />
                            </div>
                            <div className='cardInputBlock'>
                                <AiFillCalendar />
                                <CardExpiryElement className='paymentInput' />
                            </div>
                            <div className='cardInputBlock'>
                                <MdVpnKey />
                                <CardCvcElement className='paymentInput' />
                            </div>
                            <input
                                type='submit'
                                value={`Pay - ${orderInfo && orderInfo.totalPrice}`}
                                ref={payBtn}
                                className='submitBtn'
                            />
                        </form>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Payment;
